import {Injectable} from '@angular/core';
import {DatePipe} from '@angular/common';
import {
  StatusEventSignalCsvImportService
} from '@services/administration/machine/status-event/import/status-event-signal-csv-import.service';
import {
  StatusEventSignalCsvExportService
} from '@services/administration/machine/status-event/export/status-event-signal-csv-export.service';
import {StatusEventDetails} from '@models/machine/status-event-signal/status-event-details';
import {
  StatusEventSignalValueParsingType
} from '@constants/machine/status-event-signal/status-event-signal-value-parsing-type.enum';
import {
  StatusEventSignalContentPreviewService
} from '@services/administration/machine/status-event/preview/status-event-signal-content-preview.service';
import {StatusEventSignalConvertService} from '@services/administration/machine/status-event/convert/status-event-signal-convert.service';
import {StatusEventSignalEventsDetails} from '@models/machine/status-event-signal/status-event-signal-events-details';
import {
  StatusEventSignalValidatorService
} from '@services/administration/machine/status-event/validator/status-event-signal-validator.service';


@Injectable({
  providedIn: 'root'
})
export class StatusEventSignalService {

  constructor(private datePipe: DatePipe,
              private csvImport: StatusEventSignalCsvImportService,
              private csvExport: StatusEventSignalCsvExportService,
              private htmlPreview: StatusEventSignalContentPreviewService,
              private errorDetailsConvertor: StatusEventSignalConvertService,
              private eventsValidator: StatusEventSignalValidatorService) {
  }


  public importCsv(parsingType: StatusEventSignalValueParsingType, inputString: string): Map<string, StatusEventDetails> {
    return this.csvImport.parseCsvToStatusEventDetails(parsingType, inputString);
  }

  public exportCsv(details: Map<string, StatusEventDetails>): string {
    return this.csvExport.parseStatusEventDetailsToCsv(details);
  }

  public generateHtml(details: Map<string, StatusEventDetails>): string {
    return this.htmlPreview.parseStatusEventDetailsToHtmlTable(details);
  }

  public generateExportFileName(signalName: string): string {
    return signalName + '_' + this.currentDateString() + '_details.csv';
  }

  public convertStatusEventDetailsToObject(details: StatusEventSignalEventsDetails): any {
    return this.errorDetailsConvertor.convertStatusEventSignalEventsDetailsToObject(details);
  }

  public convertObjectToStatusEventDetails(details: any): StatusEventSignalEventsDetails {
    return this.errorDetailsConvertor.convertObjectToStatusEventSignalEventsDetails(details);
  }

  public validateStatusEventDefinitions(parsingType: StatusEventSignalValueParsingType, definitions: Map<string, StatusEventDetails>) {
    this.eventsValidator.validateStatusEventDefinitions(parsingType, definitions);
  }

  private currentDateString(): string {
    const date = new Date();
    let dateString = this.datePipe.transform(date, 'yyyy-MM-dd_HH:mm:ss');
    if (dateString === null) {
      dateString = '';
    }
    return dateString;
  }


}
